import {
    PaymentScheduleActions,
    PaymentScheduleAmountTypes,
    PaymentScheduleDate
} from '../../../graphql/payment_schedule.datatypes';
import React, {useEffect, useState} from 'react';
import {getHandleFieldChange, getHasError} from '../../../utils/formHelpers';
import validate from 'validate.js';
import {colors, Grid, IconButton, InputAdornment, TextField, Theme} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import {makeStyles} from '@material-ui/core/styles';
import {WCVDatePicker} from '../../../components/DateUtilsProvider/WCVDatePicker';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    textFieldInput: {
        fontSize: 12,
        height: 'auto',
    },
    dateInput: {
        '& .MuiInputAdornment-root': {
            marginLeft: 0,
        },
    },
    deleteButton: {
        margin: theme.spacing(1),
        color: theme.palette.error.dark,
    },
    saveButton: {
        margin: theme.spacing(1),
        color: colors.green[300],
    },
    icon: {
        fontSize: '1.2rem',
    },
}));

const PaymentScheduleDateEdit = (props: { paymentScheduleDate: PaymentScheduleDate, updatePaymentDate: (paymentScheduleDate: PaymentScheduleDate) => void, deletePaymentDate: (id: number) => void }) => {
    const {paymentScheduleDate, updatePaymentDate, deletePaymentDate} = props;
    const classes = useStyles();
    const [formState, setFormState] = useState({...paymentScheduleDate});

    useEffect(() => {
        setFormState({...paymentScheduleDate});
    }, [paymentScheduleDate]);

    const [errors, setErrors] = useState({
        isValid: false,
        errors: {}
    });

    //2. Setup helper functions for form
    const handleFieldChange = getHandleFieldChange(setFormState);
    const hasError = getHasError(errors);

    //3. setup validation and error hook
    const validateSchema: any = {
        title: {
            presence: {allowEmpty: false, message: 'is required'},
        },
        due_date: {
            presence: {allowEmpty: false, message: 'is required'},
        },
        amount: {
            presence: {allowEmpty: false, message: 'is required'},
        },
    };
    useEffect(() => {
        const newErrors = validate(formState, validateSchema);

        setErrors(state => ({
            ...state,
            isValid: !newErrors,
            errors: newErrors || {}
        }));

        if (!newErrors) {
            updatePaymentDate(formState);
        }
    }, [formState]);

    return (
        <Grid container spacing={3}>
            <Grid item xs={4}>
                <TextField
                    {...hasError('title')}
                    fullWidth
                    label="Title"
                    name="title"
                    onChange={handleFieldChange}
                    value={formState.title}
                />
            </Grid>

                <Grid item xs={3}>
                    <WCVDatePicker
                        {...hasError('due_date')}
                        margin="dense"
                        name="due_date"
                        label="Due by / Cancel on"
                        inputVariant="standard"
                        onChange={(date, value) => {
                            setFormState({
                                ...formState,
                                due_date: value ? value : undefined
                            })
                        }}
                        value={formState.due_date}
                    />
                </Grid>

            <Grid item xs={2}>
                <TextField
                    {...hasError('action_type')}
                    fullWidth
                    label="Action Type"
                    name="action_type"
                    onChange={handleFieldChange}
                    value={formState.action_type}
                    select
                    // eslint-disable-next-line react/jsx-sort-props
                    SelectProps={{native: true}}
                >
                    {PaymentScheduleActions.map((type, i) => (
                        <option key={type.name} value={i}>
                            {type.name}
                        </option>
                    ))}
                </TextField>
            </Grid>

            <Grid item xs={2}>
                <TextField
                    {...hasError('amount')}
                    fullWidth
                    label="Amount"
                    type="numeric"
                    name="amount"
                    onChange={handleFieldChange}
                    onFocus={event => event.target.select()}
                    value={formState.amount}
                    InputProps={{
                        inputProps: {
                            onClick: (e) => e.currentTarget.select(),
                        },
                        endAdornment: (
                            <InputAdornment position="end">
                                <TextField
                                    name="amount_type"
                                    onChange={handleFieldChange}
                                    value={formState.amount_type}
                                    select
                                    style={{width: 55}}
                                    // eslint-disable-next-line react/jsx-sort-props
                                    SelectProps={{native: true}}
                                >
                                    {PaymentScheduleAmountTypes.map((type, i) => (
                                        <option key={type.name} value={i}>
                                            {type.name}
                                        </option>
                                    ))}
                                </TextField>
                            </InputAdornment>
                        )
                    }}
                />
            </Grid>

            <Grid item xs={1}>
                <IconButton className={classes.deleteButton} onClick={() => deletePaymentDate(formState.id)}>
                    <DeleteIcon className={classes.icon}/>
                </IconButton>
            </Grid>
        </Grid>
    );
};

export default PaymentScheduleDateEdit;
